import { cn } from '../../lib/utils.js';

interface StatusDotProps {
  status: 'online' | 'offline' | 'warning' | 'error' | 'idle';
  className?: string;
  pulse?: boolean;
  size?: 'sm' | 'md' | 'lg';
}

const statusColors = {
  online: 'bg-emerald-500',
  offline: 'bg-slate-500',
  warning: 'bg-amber-500',
  error: 'bg-red-500',
  idle: 'bg-blue-500',
};

const statusSizes = {
  sm: 'h-1.5 w-1.5',
  md: 'h-2.5 w-2.5',
  lg: 'h-3 w-3',
};

export function StatusDot({ status, className, pulse, size = 'md' }: StatusDotProps) {
  return (
    <span
      className={cn(
        'inline-block rounded-full',
        statusColors[status],
        statusSizes[size],
        pulse && 'animate-pulse',
        className,
      )}
    />
  );
}